import { ApiError } from "@softmax/observatory-client/transport";
import { publicRead } from "@softmax/web-features/data/public-api";

type CommunityRead<T> =
  | { status: "ok"; data: T }
  | { status: "not-found" }
  | { status: "unavailable" };

export async function readCommunity<T>({
  path,
  signal,
}: {
  path: string;
  signal?: AbortSignal | undefined;
}): Promise<CommunityRead<T>> {
  const [result] = await Promise.allSettled([publicRead<T>({ path, signal })]);

  if (result.status === "fulfilled")
    return { status: "ok", data: result.value };

  signal?.throwIfAborted();

  if (result.reason instanceof ApiError && result.reason.status === 404) {
    return { status: "not-found" };
  }

  console.error("Public community read failed", path, result.reason);
  return { status: "unavailable" };
}
